/** Product name shown on the mobile handoff page and QR install flow. */
export const OURO_APP_NAME = 'Ouro';

/** Full-screen demo shell (static build under /demos/ouro/). */
export const OURO_MOBILE_SHELL_PATH = '/demos/ouro/mobile.html';

const DEFAULT_ORIGIN = 'https://www.neevii.com';

function resolveOrigin(origin) {
  if (origin && typeof origin === 'string') {
    return origin.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return DEFAULT_ORIGIN;
}

/** Absolute URL for the Ouro mobile shell — used by QR codes and copy-link actions. */
export function getOuroMobileShellUrl(origin) {
  const base = resolveOrigin(origin);
  const path = OURO_MOBILE_SHELL_PATH.startsWith('/')
    ? OURO_MOBILE_SHELL_PATH
    : `/${OURO_MOBILE_SHELL_PATH}`;
  return `${base}${path}`;
}

/** @deprecated Use getOuroMobileShellUrl */
export const getJessicaMobileUrl = getOuroMobileShellUrl;

/** @deprecated Use OURO_MOBILE_SHELL_PATH */
export const JESSICA_MOBILE_PATH = OURO_MOBILE_SHELL_PATH;
